module.exports = false;



//////////////////
// WEBPACK FOOTER
// /usr/src/app/~/core-js/modules/_library.js
// module id = 157
// module chunks = 168707334958949